var n = function(i) {
  return i === void 0;
};
export {
  n as i
};
